<template>
<component :is="component" v-on="$listeners" :class="bem('container')" v-bind="$attrs">
    <!-- Reference -->
    <slot />
    <transition @after-leave="afterLeave" name="g-fade">
        <span
            v-if="lazy ? hasShow : true"
            v-show="isShowPopper"
            ref="content"
            :class="[bem([theme, {arrow}]), popoverClass]"
            :style="{zIndex: zIndex}"
        >
            <template>
                <!-- 浮层内容 -->
                <slot name="content" :close="() => changeVisible(false)" />
                <div x-arrow v-if="arrow" :class="bem('arrow')" />
            </template>
        </span>
    </transition>
</component>

</template>
<script>
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.array.includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bemMixin, isUndef } from '../utils';
import Popper from 'popper.js';
import popupManager from '@gaoding/popup-manager';
import { on, off } from '../utils/dom';
export default {
  name: 'g-popover',
  mixins: [bemMixin],
  props: {
    // 是否显示
    visible: {
      type: Boolean,
      default: undefined
    },
    // 默认是否显示
    defaultVisible: {
      type: Boolean,
      default: false
    },
    // 惰性渲染
    lazy: {
      type: Boolean,
      default: true
    },
    // 自定义 popover 插入元素，确保能通过 `document.querySelector` 找到
    el: String,
    // 固定定位，popperJS options.positionFixed
    fixed: {
      type: Boolean,
      default: false
    },
    // popperJS options.modifiers
    modifiers: Object,
    // 显示位置
    placement: {
      type: String,
      // 'top-start' 'top' 'top-end' 'left-start' 'left' 'left-end' 'bottom-start' 'bottom' 'bottom-end'
      default: 'bottom'
    },
    // 实际渲染的组件
    component: {
      type: [String, Object],
      default: 'span'
    },
    // 是否插入到 document.body 节点中
    appendToBody: {
      type: Boolean,
      default: false
    },
    // 浮层最外层 class
    popoverClass: {
      type: [String, Array],
      default: ''
    },
    // 主题色
    theme: {
      // 'dark' / ‘light’
      type: String,
      default: 'light'
    },
    // 是否显示箭头
    arrow: {
      type: Boolean,
      default: true
    },
    // 触发事件
    trigger: {
      type: String,
      default: 'hover',
      validator: function validator(value) {
        return ['click', 'hover', 'focus'].includes(value);
      }
    },
    // 延迟多久消失
    delayonMouseLeave: {
      type: Number,
      default: 100
    },
    // 延迟多久显示
    delayonMouseEnter: {
      type: Number,
      default: 0
    }
  },

  data() {
    var isShowPopper;

    if (!isUndef(this.visible)) {
      isShowPopper = this.visible;
    } else {
      isShowPopper = this.defaultVisible;
    }

    return {
      isShowPopper,
      zIndex: 0,
      hasShow: isShowPopper
    };
  },

  computed: {
    reference() {
      return !this.$isServer ? this.el ? document.querySelector(this.el) : this.$el : null;
    }

  },
  watch: {
    isShowPopper(value) {
      if (value && !this.hasShow) this.hasShow = true;

      if (value) {
        this.$emit('show');
        popupManager.pushStack(this);
        this.createPopperIfNeeded();
      } else {
        this.$emit('hide');
      }
    },

    visible(value) {
      this.isShowPopper = value;
    },

    el(value) {
      this.$popper && this.$popper.destroy();
      this.createPopper();
    }

  },

  mounted() {
    this.appendToBodyIfNeeded();

    if (this.isShowPopper) {
      popupManager.pushStack(this);
      this.createPopper();
    }

    this.onReferenceEvent();
  },

  updated() {
    this.updatePopper();
  },

  beforeDestroy() {
    this.offReferenceEvent();
    this.doDestroy();
  },

  methods: {
    appendToBodyIfNeeded() {
      var _this = this;

      if (this.appendToBody) {
        if (!this.lazy) {
          document.body.appendChild(this.$refs.content);
          this.appendedToBody = true;
        } else if (!this.hasShow) {
          this.$nextTick(function () {
            if (_this.$refs.content) {
              document.body.appendChild(_this.$refs.content);
              _this.appendedToBody = true;
            }
          });
        }
      }
    },

    createPopper() {
      if (!this.reference || !this.$refs.content) return;
      this.$popper = new Popper(this.reference, this.$refs.content, this.getPopperConfig());
      this.onPopperEvent();
    },

    createPopperIfNeeded() {
      var _this2 = this;

      if (this.$popper) return;

      if (!this.lazy) {
        this.createPopper();
      } else {
        this.$nextTick(function () {
          _this2.createPopper();
        });
      }
    },

    updatePopper() {
      if (!this.$popper) return;
      this.$popper.scheduleUpdate();
    },

    getPopperConfig() {
      var _this3 = this;

      return {
        onCreate: function onCreate(data) {
          data.instance.popper.style.zIndex = _this3.zIndex;

          _this3.$emit('create', data);
        },
        onUpdate: function onUpdate(data) {
          if (_this3.isShowPopper) {
            data.instance.popper.style.zIndex = _this3.zIndex;
          }
        },
        modifiers: Object.assign({
          preventOverflow: {
            padding: 0
          },
          flip: {
            enabled: false
          }
        }, this.modifiers),
        placement: this.placement,
        positionFixed: this.fixed,
        removeOnDestroy: false
      };
    },

    onReferenceEvent() {
      switch (this.trigger) {
        case 'click':
          on(this.reference, 'click', this.handleReferenceClick);
          break;

        case 'hover':
          on(this.reference, 'mouseenter', this.handleReferenceMouseenter);
          on(this.reference, 'mouseleave', this.handleReferenceMouseleave);
          break;

        case 'focus':
          on(this.reference, 'focus', this.handleReferenceMouseenter);
          on(this.reference, 'blur', this.handleReferenceMouseleave);
          break;
      }
    },

    offReferenceEvent() {
      switch (this.trigger) {
        case 'click':
          off(document, 'click', this.handleClickOutside);
          break;
      }
    },

    handleReferenceClick(e) {
      var _this4 = this;

      this.changeVisible(!this.isShowPopper);
      this.appendToBodyIfNeeded();
      this.createPopperIfNeeded();
      this.$nextTick(function () {
        if (_this4.isShowPopper) {
          on(document, 'click', _this4.handleClickOutside);
        } else {
          off(document, 'click', _this4.handleClickOutside);
        }
      });
    },

    changeVisible(value) {
      if (!isUndef(this.visible)) {
        this.$emit('update:visible', value);
      } else {
        this.isShowPopper = value;
      }
    },

    handleClickOutside(e) {
      if (!this.reference || this.elementContains(this.reference, e.target) || !this.$refs.content || this.elementContains(this.$refs.content, e.target)) {
        return;
      }

      this.changeVisible(false);
      off(document, 'click', this.handleClickOutside);
    },

    onPopperEvent() {
      if (this.trigger === 'hover') {
        on(this.$refs.content, 'mouseenter', this.handleContentMouseenter);
        on(this.$refs.content, 'mouseleave', this.handleContentMouseleave);
      }
    },

    offPopperEvent() {
      off(this.$refs.content, 'mouseenter', this.handleContentMouseenter);
      off(this.$refs.content, 'mouseleave', this.handleContentMouseleave);
    },

    handleContentMouseenter() {
      this.mouseInContent = true;
    },

    handleContentMouseleave() {
      this.mouseInContent = false;
      this.changeVisible(false);
    },

    afterLeave() {
      popupManager.popStack(this);
    },

    doDestroy() {
      this.offPopperEvent();

      if (this.$popper) {
        this.$popper.destroy();
        this.$popper = null;
      }

      if (this.appendToBody && this.appendedToBody && this.$refs.content) {
        this.appendedToBody = false;
        document.body.removeChild(this.$refs.content);
      }
    },

    handleReferenceMouseenter(e) {
      var _this5 = this;

      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        if (_this5.isShowPopper === true || _this5.leaveing) return;

        _this5.changeVisible(true);

        _this5.appendToBodyIfNeeded();

        _this5.createPopperIfNeeded();
      }, this.delayonMouseEnter);
    },

    handleReferenceMouseleave() {
      var _this6 = this;

      clearTimeout(this._timer);
      this._timer = setTimeout(function () {
        if (_this6.mouseInContent) return;

        _this6.changeVisible(false);
      }, this.delayonMouseLeave);
    },

    elementContains(elm, otherElm) {
      if (typeof elm.contains === 'function') {
        return elm.contains(otherElm);
      }

      return false;
    }

  }
};
</script>
<style>
.g-fade-enter {
  opacity: 0;
}
.g-fade-enter-active {
  transition: opacity 0.3s ease;
}
.g-fade-leave-active {
  transition: opacity 0.3s ease;
}
.g-fade-leave-to {
  opacity: 0;
}
.g-popover__container {
  display: inline-block;
}
.g-popover {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  position: relative;
  color: #000000;
  background: #fff;
}
.g-popover * {
  box-sizing: border-box;
}
.g-popover .g-popover__arrow {
  position: absolute;
}
.g-popover--arrow .g-popover__arrow {
  border-width: 5px;
  box-sizing: border-box;
  position: absolute;
  width: 10px;
  height: 10px;
  border-color: #fff;
  border-style: solid;
  border-radius: 2px;
  transform: rotate(45deg);
}
.g-popover--arrow[x-placement^="top"] {
  margin-bottom: 8px;
}
.g-popover--arrow[x-placement^="top"] .g-popover__arrow {
  bottom: -4px;
  border-top-color: transparent;
  border-left-color: transparent;
}
.g-popover--arrow[x-placement^="top"] .g-popover__arrow {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
}
.g-popover--arrow[x-placement="top-start"] .g-popover__arrow,
.g-popover--arrow[x-placement="bottom-start"] .g-popover__arrow {
  transform: translateX(-4px) rotate(45deg);
}
.g-popover--arrow[x-placement="top-end"] .g-popover__arrow,
.g-popover--arrow[x-placement="bottom-end"] .g-popover__arrow {
  transform: translateX(4px) rotate(45deg);
}
.g-popover--arrow[x-placement^="bottom"] {
  margin-top: 8px;
}
.g-popover--arrow[x-placement^="bottom"] .g-popover__arrow {
  top: -4px;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.g-popover--arrow[x-placement^="bottom"] .g-popover__arrow {
  box-shadow: -3px -3px 5px rgba(0, 0, 0, 0.06);
}
.g-popover--arrow[x-placement^="right"] {
  margin-left: 5px;
}
.g-popover--arrow[x-placement^="right"] .g-popover__arrow {
  left: -4px;
  border-right-color: transparent;
  border-top-color: transparent;
}
.g-popover--arrow[x-placement^="right"] .g-popover__arrow {
  box-shadow: -3px 3px 7px rgba(0, 0, 0, 0.07);
}
.g-popover--arrow[x-placement="right-start"] .g-popover__arrow,
.g-popover--arrow[x-placement="left-start"] .g-popover__arrow {
  transform: translateY(-8px) rotate(45deg);
}
.g-popover--arrow[x-placement="right-end"] .g-popover__arrow,
.g-popover--arrow[x-placement="left-end"] .g-popover__arrow {
  transform: translateY(8px) rotate(45deg);
}
.g-popover--arrow[x-placement^="left"] {
  margin-right: 5px;
}
.g-popover--arrow[x-placement^="left"] .g-popover__arrow {
  right: -4px;
  border-bottom-color: transparent;
  border-left-color: transparent;
}
.g-popover--arrow[x-placement^="left"] .g-popover__arrow {
  box-shadow: 3px -3px 7px rgba(0, 0, 0, 0.07);
}
.g-popover.g-popover--light {
  color: #000000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}
.g-popover.g-popover--dark {
  color: #fff;
  background: #000000;
}
.g-popover.g-popover--dark.g-popover--arrow .g-popover__arrow {
  border-width: 5px;
  box-sizing: border-box;
  position: absolute;
  width: 10px;
  height: 10px;
  border-color: #000000;
  border-style: solid;
  border-radius: 2px;
  transform: rotate(45deg);
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement^="top"] {
  margin-bottom: 8px;
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement^="top"] .g-popover__arrow {
  bottom: -4px;
  border-top-color: transparent;
  border-left-color: transparent;
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement="top-start"] .g-popover__arrow,
.g-popover.g-popover--dark.g-popover--arrow[x-placement="bottom-start"] .g-popover__arrow {
  transform: translateX(-4px) rotate(45deg);
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement="top-end"] .g-popover__arrow,
.g-popover.g-popover--dark.g-popover--arrow[x-placement="bottom-end"] .g-popover__arrow {
  transform: translateX(4px) rotate(45deg);
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement^="bottom"] {
  margin-top: 8px;
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement^="bottom"] .g-popover__arrow {
  top: -4px;
  border-right-color: transparent;
  border-bottom-color: transparent;
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement^="right"] {
  margin-left: 5px;
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement^="right"] .g-popover__arrow {
  left: -4px;
  border-right-color: transparent;
  border-top-color: transparent;
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement="right-start"] .g-popover__arrow,
.g-popover.g-popover--dark.g-popover--arrow[x-placement="left-start"] .g-popover__arrow {
  transform: translateY(-8px) rotate(45deg);
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement="right-end"] .g-popover__arrow,
.g-popover.g-popover--dark.g-popover--arrow[x-placement="left-end"] .g-popover__arrow {
  transform: translateY(8px) rotate(45deg);
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement^="left"] {
  margin-right: 5px;
}
.g-popover.g-popover--dark.g-popover--arrow[x-placement^="left"] .g-popover__arrow {
  right: -4px;
  border-bottom-color: transparent;
  border-left-color: transparent;
}

</style>
